import { refreshCartAndSeatMap } from '@/app/order/[performanceId]/seat-map/action'
import useCartStore from '@/stores/cartStore'
import Icon from '@a24/ui/Icon'
import Link from '@a24/ui/Link'
import Popover from '@a24/ui/Popover'
import Title from '@a24/ui/Title'
import { type RefObject, useTransition } from 'react'

interface IProps {
  ref: RefObject<HTMLDivElement | null>
  performanceId?: string
}
const TimerPopover = ({ ref, performanceId }: IProps) => {
  const [isPending, startTransition] = useTransition()
  const { resetOrderCount } = useCartStore()

  return (
    <Popover
      popover='manual'
      className={
        'top-[50%] translate-y-[-50%]  px-12 md:px-28 py-12 md:py-20 border w-[90vw] md:w-auto border-heritage-black-full backdrop:bg-heritage-black-full/20 rounded bg-heritage-white-full left-[50%] translate-x-[-50%] '
      }
      ref={ref}
      buttonProps={{ className: 'hidden' }}
    >
      <div className='relative text-center md:max-w-96 mx-auto'>
        <Title
          level='h2'
          text='Your timer has expired'
          className='heading-md'
        />
        <p className='body-md mt-8'>
          The timer on your tickets has expired. Your cart will be cleared but
          you can still add the tickets again if they are available.
        </p>
        <div className='flex  flex-wrap justify-center gap-4 mt-10'>
          <Link href='/shows' className='button-secondary w-full md:w-auto'>
            Back to Shows
          </Link>
          {performanceId && (
            <Link
              href={`/order/${performanceId}/seat-map`}
              className='button-primary w-full md:w-auto'
              onClick={() => {
                startTransition(() => {
                  resetOrderCount()
                  refreshCartAndSeatMap(performanceId)
                })
              }}
            >
              Book Again
              <Icon name='arrow-right' width={8} height={8} className='ml-1' />
            </Link>
          )}
        </div>
      </div>
    </Popover>
  )
}

export default TimerPopover
